import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, map, take, tap } from 'rxjs/operators';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';
import { ApplicationService } from '../../services/application/application.service';
import { StepNavigationService } from '../../services/step-navigation/step-navigation.service';
import { isUnsupportedPurpose } from '../../constants/application-purpose-codes';

export const UnsupportedApplicationResolver = (
    route: ActivatedRouteSnapshot,
) => {
    const applicationService = inject(ApplicationService);
    const stepService = inject(StepNavigationService);
    const router = inject(Router);

    const applicationId = route?.paramMap.get('id');

    if (!applicationId) {
        console.error(
            'Tried to navigate to an unsupported application page but Application ID is not defined.',
        );

        return navigateToHome(router);
    }

    // Fetch the application state to verify it's an unsupported application and initialize the steps
    return applicationService.getApplicationState(applicationId).pipe(
        take(1),
        tap((state) => {
            const purpose = state?.applicationPurpose;
            if (!isUnsupportedPurpose(purpose)) {
                throw new Error(
                    `Application ${applicationId} is not an unsupported type (purpose='${purpose}').`,
                );
            }

            stepService.initializeUnsupportedApplicationSteps(applicationId);
        }),
        map(() => true),
        catchError((err) => {
            console.error(
                'Error initializing unsupported application page:',
                err,
            );
            return navigateToHome(router);
        }),
    );
};
